import { useEffect, useState } from "react";
import { SectorOption } from "./inputSetor";
import { baseApiService } from "../../../services/api/axios-config/axios-config";

export function useSectorById(idSetor: string) {
  const [setores, setSetores] = useState<SectorOption[]>([]);
  useEffect(() => {
    const fetchSetores = async () => {
      const response = await baseApiService.get("sector-category/select");
      setSetores(response.data.data || []);
    };
    fetchSetores();
  }, []);

  return setores.find((s) => s.id === idSetor) || null;
}